interface MenuButtonProps {
  title: string | JSX.Element;
  icon: JSX.Element;
  testId: string;
  onClick: () => void;
  isEnabled?: boolean;
  isCancelAction?: boolean;
}

export default function MenuButton({
  title,
  icon,
  testId,
  onClick,
  isEnabled = true,
  isCancelAction = false,
}: MenuButtonProps) {
  const classes = `${isEnabled ? "" : "disabled"}${isCancelAction ? " cancel-action" : ""}`;
  return (
    <button type="button" onClick={onClick} data-testid={testId} className={`action-popover-button ${classes}`}>
      {icon}
      <span className="action-popover-label">{title}</span>
    </button>
  );
}

MenuButton.defaultProps = {
  isEnabled: true,
  isCancelAction: false,
};
